<template>
    <!-- Modal Prensa -->
	<div class="modal fade" id="contactoModal" tabindex="-1" aria-labelledby="contactoModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-fullscreen">
			<div class="modal-content">
				<button type="button" class="btn-close btn-close-white ms-auto fs-1" data-bs-dismiss="modal"
					aria-label="Close"></button>
				<div class="modal-body">
					<div class="container h-100">
						<div class="row h-100 justify-content-center align-items-center">
							<div class="col-md-10">
								<div class="row justify-content-center">
									<div class="col-sm-4 text-center mb-5 texto-modal">
										<h1 class="fw-600">CONTACTO DE PRENSA</h1>
										<hr class="linea-titulos">
									</div>
								</div>
								<div class="row justify-content-center">
                                    <div class="col-md-5 mb-5 texto-modal">
                                        <img src="/img/MatiasEduardoMaciel.jpg"
                                            alt="Foto de Matías Maciel"
											class="rounded-circle mb-3 d-none d-md-block mx-auto" width="130" height="130">
										<h5 class="fw-600">Matías Maciel</h5>
										<p class="mb-0">Director de Asuntos Públicos, Comunicación y Sustentabilidad</p>
										<a class="text-decoration-none"
											href="mailto:prensa.argentina@renault.com">prensa.argentina@renault.com</a>
									</div>
                                    <div class="col-md-5 mb-5 texto-modal">
                                        <img src="/img/VirginiaRivera.jpg"
                                            alt="Foto de Virginia Rivera"
											class="rounded-circle mb-3 d-none d-md-block mx-auto" width="130" height="130">
										<h5 class="fw-600">Virginia Rivera</h5>
										<p class="mb-0">Gerente de Comunicaciones</p>
										<a class="text-decoration-none"
											href="mailto:prensa.argentina@renault.com">prensa.argentina@renault.com</a>
									</div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-5 mb-5 texto-modal">
										<img src="/img/FedericoAmateis.jpg"
                                            alt="Foto de Federico Amateis"
											class="rounded-circle mb-3 d-none d-md-block mx-auto" width="130" height="130">
										<h5 class="fw-600">Federico Amateis</h5>
										<p class="mb-0">Responsable Comunicación Córdoba</p>
										<a class="text-decoration-none"
											href="mailto:prensa.argentina@renault.com">prensa.argentina@renault.com</a>
									</div>
                                    <div class="col-md-5 mb-5 texto-modal">
										<img src="/img/TomasOrdonez.jpg"
                                            alt="Foto de Tomás Ordoñez"
											class="rounded-circle mb-3 d-none d-md-block mx-auto" width="130" height="130">
										<h5 class="fw-600">Tomás Ordoñez</h5>
										<p class="mb-0">Responsable de Comunicación Externa</p>
										<a class="text-decoration-none"
											href="mailto:prensa.argentina@renault.com">prensa.argentina@renault.com</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    mounted() {
    
    },
};
</script>